export default function IconSkipNext() {
  return (
    <svg width="32" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.4353 31.2944C2.43359 32.9493 7.10566e-08 31.5936 6.5238e-07 28.2688L4.94229e-06 3.73356C5.52419e-06 0.405479 2.4336 -0.948444 5.43531 0.704856L27.7481 13.0035C30.7508 14.6589 30.7508 17.341 27.7481 18.996L5.4353 31.2944Z"
        fill="currentColor" />
      <path
        d="M34.666 2.66667C34.666 1.19391 35.8599 0 37.3327 0C38.8054 0 39.9993 1.19391 39.9993 2.66667V29.3333C39.9993 30.8061 38.8054 32 37.3327 32C35.8599 32 34.666 30.8061 34.666 29.3333V2.66667Z"
        fill="currentColor" />
    </svg>
  );
}
